export default __webpack_public_path__ + "static/media/partner-icon.bacef66e.png";